import { Injectable, OnDestroy, HostListener, Directive } from '@angular/core';
import { Router } from "@angular/router";
import { EmitterService } from '../services/emitter.service';
import { TranslateService } from "@ngx-translate/core";
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import * as _ from 'underscore';
import { AjaxService } from './ajax.service';
import { Observable, of, Subject } from 'rxjs';
import { finalize, share, tap, takeUntil } from 'rxjs/operators';

@Directive()
@Injectable()
export class GameWindowService implements OnDestroy {
  switchInputStatus: boolean;
  gameId;
  gameTypeVal;
  isLoggedIn;
  gameType;
  allSlotsData = null;
  favouriteGamesObj = {};
  allSlotsDataCallStack = [];
  allSlotsDataMap;
  langCode;
  _lobbyDetails: any;
  lobbyDetailsCallStack: any = [];
  lobbyObservable:Observable<any>;
  gamesObservable:Observable<any>;
  favGamesObservable:Observable<any>;
  favouriteObservable:Observable<any>;
  favGamesDataCallStack: any = [];
  lastPlayedGamesDataCallStack: any = [];
  _gamesGroupedByGameGroup = {};
  destroy$: Subject<boolean> = new Subject<boolean>();
  multiLingualGameObj = {};
  forceLatestPlayedGames = false;
  latestPlayedGamesObject = null; 
  isFavoriteGamesAvailable = false;
  providerList = [];
  @HostListener('window:message', ['$event'])
  onMessage(e) {
    if (e) {
      this.reloadGame(e.gameId, e.user);
    }
  }
  constructor(
    private ajaxService: AjaxService,
    private emitterService: EmitterService,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
  }

  // getAllCasinoGames() {
  //   if (this.allSlotsData) {
  //     this.setAllSlotData(this.allSlotsData);
  //     return this.allSlotsData;
  //   } else{
  //     let localGamesObservable: Observable<any>;
  //     if (this.gamesObservable) {
  //       localGamesObservable = this.gamesObservable;
  //     } else {
  //       let gamesRequest;
  //       gamesRequest = this.ajaxService.getGamesWithGameGroup();
  //       this.gamesObservable = gamesRequest.pipe(tap(allGames=>{
  //         this.allSlotsData = this.filterPragmaticGames(allGames);
  //         this.setAllSlotData(this.allSlotsData);
  //         this.setMultiLingualGameObj(allGames);
  //         this.groupGamesByGameGroups();
  //         this.emitterService.broadcastAllGamesEmitter("");
  //       }), share(), finalize(() =>
  //         this.gamesObservable = null
  //       ));
  //       localGamesObservable = this.gamesObservable;
  //     }
  //     return localGamesObservable; 
  //   }
  // }


  filterPragmaticGames(allSlotsData): any {
    let gamesArr = _.filter(allSlotsData, function (game) {
      if (game.gameType === "hidden") {
        return false;
      } else {
        return true;
      }
    });
    return gamesArr;
  }
  createMap(allgames) {
    this.allSlotsDataMap = _.indexBy(allgames, 'gameCode');
    this.setAllSlotDataMap(this.allSlotsDataMap);
  }
  // casino games Gamelauncher function
  loadGame(gameType, gameId, gameLaunchUrlPath): void {
    let vendorSlug = this.multiLingualGameObj[gameLaunchUrlPath] ? this.multiLingualGameObj[gameLaunchUrlPath]['vendorSlug'] : null;
    Promise.resolve(this.ajaxService.lauchGame(gameType, gameId, this.langCode)).then(resp => {
      delete resp.gameDetails.isMobile;
      this.gameType = gameType;
      if (resp.gameDetails.netentDetails) {
        resp.gameDetails.netentDetails["language"] = resp.language;
      }
      resp = resp.gameDetails;
      const ww = document.body.clientWidth;
      if (ww <= 1024) {
        if (resp.netentDetails) {
          $("#gameIframeWrapper").append('<div id="netentgame"></div>');
          this.netentScript(resp.netentDetails, 'mobile', "iframe");
        // } else if (resp && resp.url && gameType === "realgames") {
        //   window.location.href = resp.url;
        } else {
          // this.langCode ? '' : this.langCode = localStorage.getItem('langCode');
          // this.router.navigate([this.langCode+'/gameplay/' + gameId], {queryParams: {'aspectRatio': 2,'vendor': vendorSlug}});
          this.gameUrllaunch(resp, vendorSlug);
        }
        return;
      }
      this.gameUrllaunch(resp, vendorSlug);
    });
  }

  reloadGame(gameId, user): void {
    gameId = "playngo" + gameId;
    let gameType = "realgames";
    Promise.resolve(this.ajaxService.lauchGame(gameType, gameId, this.langCode)).then(resp => {
      delete resp.gameDetails.isMobile;
      resp = resp.gameDetails;
      this.gameUrllaunch(resp, 'play-n-go');
    })
  }

  gameUrllaunch(resp, vendorSlug) {
    let $iframe;
    let responseUrl;
    $("#gameIframeWrapper, .playNGoWrap").html('');
    $("#gameIframeWrapper, .playNGoWrap").removeClass('iframe-loaded');
    if (resp["netentDetails"] && vendorSlug == 'netent') {
      $("#gameIframeWrapper").append('<div id="netentgame"></div>');
      this.netentScript(resp.netentDetails, 'desktop');
    } else if (resp["url"]) {
      $("#idPlayNGo").html('');
      responseUrl = resp["url"];
      let checkPlayNGo = "";
      if (resp.url.includes('playngonetwork')) {
        responseUrl = responseUrl.replace("lobby", "origin").concat("&embedmode=iframe");
        if (!responseUrl.includes('origin')){
          responseUrl = responseUrl.concat("&origin=" + window.location.origin);
        }
        checkPlayNGo = "playngo";
      }
      $iframe = $('<iframe name="gamePlayIframe" class="'+checkPlayNGo+'" id="gamePlayIframe" src="' + responseUrl + '" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>');
    } else if (resp.length > 10) {
      $iframe = $('<iframe name="gamePlayIframe" id="gamePlayIframe" src=' + resp + ' allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>');
    } else if (resp === "session expired") {
      $iframe = "<h1>" + resp + ". Please Login.</h1>";
      $(".playNGoWrap, #gameIframeWrapper").removeClass('iframe-loaded');
    } else if (resp && (resp["problem_loading"] || resp["unable_to_find_game"])) {
      $iframe = "<h1 style='color:white'>" + resp["problem_loading"] + " " + resp["unable_to_find_game"] + "</h1>";
      $(".playNGoWrap, #gameIframeWrapper").removeClass('iframe-loaded');
    }else if (resp && (resp["error"] && resp["error"]["errorCode"] == 100190)) { 
      $iframe = "<h1>" + this.translateService.instant('errors.unableToFindGame') + "</h1>";
    }else if (resp && (resp["error"] && resp["error"]["errorCode"] == 100191)) { 
      $iframe = "<h1>" + this.translateService.instant('errors.errorsUrlEmptyResponse') + "</h1>";
    }else if (resp && (resp["error"] && resp["error"]["errorCode"] == 100187)) { 
      $iframe = "<h1>" + this.translateService.instant('errors.sessionExpired') + "</h1>";
    }else if (resp && (resp["error"] && resp["error"]["errorCode"] == 100192)) { 
      $iframe = "<h1>" + this.translateService.instant('errors.updateProfile') + "</h1>";
    } else if (resp && (resp["error"] && resp["error"]["errorCode"])) {
      $iframe = "<h1 style='color:white'>" + this.translateService.instant('errors.gamesBlocker') + "</h1>";
      $(".playNGoWrap, #gameIframeWrapper").removeClass('iframe-loaded');
      //Vår ansökan för den svenska spellicensen är under behandling. Fram tills godkännande är Registrering, Insättning och Spel blockerat.
      if (vendorSlug === 'play-n-go') {
        $(".playNGoWrap").append($iframe);
      }
    } else {
      $iframe = "<h1 class='gameNotFound'> " + this.translateService.instant('errors.gamesNotFound') + "</h1>";
      $(".playNGoWrap, #gameIframeWrapper").removeClass('iframe-loaded');
    }

    $("#gameIframeWrapper").append($iframe);

    // Below Functionality is to check Play'n Go games
    setTimeout(() => {
      if (vendorSlug === 'play-n-go') {
        $(".playNGoWrap").addClass('iframe-loaded');
      } else {
        $("#gameIframeWrapper").addClass('iframe-loaded');
      }
    }, 3000);

    setTimeout(() => {
      $('#gamePlayIframe').on('load', () => {
        /* Blueprint vendor's postMessage listeners:
         * CloseGame - On fatal Error redirecting it to Home page
         * requestSize - Sending width and height of the iframe container
        */
        window.parent.addEventListener("message", (e) => {
          if (e && e.data){
            if (e.data['type'] == 'closeGame') {
              this.router.navigate([this.langCode + '/']);
            } else if (e.data['type'] == 'requestSize') {
              this.blueprintPostMessage();
            }
          }
        });

        if ($("#gamePlayIframe").hasClass('playngo')) {
          this.establishCrossCommunication(responseUrl);
        }

        setTimeout(() => {
          $("#gameIframeWrapper").addClass('transparentBg');
        }, 3000);
      });

      window.onresize = () => {
        if ($("#gamePlayIframe").length > 0 && responseUrl.includes("blueprint")) {
          this.blueprintPostMessage();
        }
      };
    });
  }

  // Sending postmessage on resize Blueprint games
  blueprintPostMessage() {
    let ww = document.body.clientWidth;
    let ele = document.getElementById("gamePlayIframe") as HTMLIFrameElement;
    let contWidth, footerRibbonHeight, contHeight;
    if (ww <= 1024) {
      contWidth = window.innerWidth;
      footerRibbonHeight = $(".games_workspace").hasClass("disable-footer") ? 0 : 65;
      contHeight = window.innerHeight - footerRibbonHeight;
    } else {
      contWidth = $("#gameIframeWrapper").outerWidth();
      footerRibbonHeight = 0;
      contHeight = $("#gameIframeWrapper").outerHeight();
    }
    let data =  { type: "resize", width: contWidth, height: contHeight };
    ele.contentWindow.postMessage(data, "*");
  }

  /**
   * Redirecting to Home page on clicking Home Lobby Icon for Play'n Go games in Mobile iframe.
   * Funcationality to establish cross window communication between
   * window & iframe...
   */
  establishCrossCommunication(url) {
    let self = this;
    let GameCommunicator = {
      source: undefined,
      targetOrigin: undefined,
      init: function (element) {
        window.addEventListener("message",
          this.processGameMessage.bind(this));
        this.source = element.contentWindow;
        this.targetOrigin = url.split("?")[0];
      },
      postMessage: function (data) {
        this.source.postMessage(data, this.targetOrigin);
      },
      processGameMessage: function (e) {
        if (e && e.data && e.data['type'] === 'backToLobby'){
          let backToHome = window.parent.document.getElementsByClassName("gamewindow_close-btn");
          $(backToHome).trigger("click");
        }
      }
    };

    GameCommunicator.init(document.getElementById('gamePlayIframe'));
    GameCommunicator.postMessage({
      messageType: "addEventListener",
      eventType: "backToLobby"
    });
  }

  setAllSlotData(allSlotsData) {
    this.allSlotsData = allSlotsData;
  }

  setMultiLingualGameObj(games) {
    if(games && !games.errors){
      games.forEach(value => {
        /* ND-439 multilingual game launch changes can be modified here */
        let langBaseName = value['multilingualUrl']['en'];
        if (langBaseName) {
          this.multiLingualGameObj[langBaseName] = value;
        }
        this.multiLingualGameObj[value['gameCode']] = value;
      });
    }
  }

  getMultiLingualGameObj() {
    return this.multiLingualGameObj;
  }

  getAllSlotData() {
    return this.allSlotsData;
  }
  setAllSlotDataMap(allSlotsMap) {
    this.allSlotsDataMap = allSlotsMap;
  }

  getAllSlotDataMap(): any {
    for (let i = 0; i < 3; i++) {
      if (!this.allSlotsDataMap) {
        this.getAllCasinoGames();
      } else {
        break;
      }
    }
    return this.allSlotsDataMap;
  }


  // Desktop Netent Script
  netentScript(resp, device, launchType?) {
    if (!window["netent"]) {
      let gameServerUrl = resp.staticServer;
      let netentScript = document.createElement('script');
      netentScript.onload = () => {
        this.loadNetentGames(resp, device, launchType);
      };
      netentScript.setAttribute('src', gameServerUrl + '/gameinclusion/library/gameinclusion.js');
      document.head.appendChild(netentScript);
    } else {
      this.loadNetentGames(resp, device, launchType);
    }
  }

  loadNetentGames(resp, device, launchType?) {
    if (device === 'mobile') {
      this.loadMobileNetentGames(resp, launchType);
    } else {
      this.loadDesktopNetentGames(resp);
    }
  }
  getAllCasinoGames() {
    if (this.allSlotsData) {
      this.setAllSlotData(this.allSlotsData);
      return of(this.allSlotsData);
    } else{
      let localGamesObservable: Observable<any>;
      if (this.gamesObservable) {
        localGamesObservable = this.gamesObservable;
      } else {
        let gamesRequest;
        gamesRequest = this.ajaxService.getGamesWithGameGroup();
        this.gamesObservable = gamesRequest.pipe(tap(allGames=>{
          if(allGames){
            this.providerList = this.groupProvidersByNames(allGames);
            this.allSlotsData = this.filterPragmaticGames(allGames);
            this.setAllSlotData(this.allSlotsData);
            this.setMultiLingualGameObj(allGames);
            this.groupGamesByGameGroups();
            this.emitterService.broadcastAllGamesEmitter("");
          }
        }), share(), finalize(() =>
          this.gamesObservable = null
        ));
        localGamesObservable = this.gamesObservable;
      }
      return localGamesObservable; 
    }
  }

  // Desktop Netent Game config
  loadDesktopNetentGames(resp) {
    let config = {
      gameId: resp.gameId,
      staticServerURL: resp.staticServer,
      gameServerURL: resp.gameServer,
      sessionId: resp.sessionId,
      targetElement: "netentgame",
      walletMode: resp.walletMode,
      language: resp.language
    };

    // Game launch successful.
    let success = function (netEntExtend) {
      netEntExtend.resize(640, 480);
      netEntExtend.addEventListener("gameReady", function () {
        netEntExtend.get("volumeLevel", function (volumeLevel) {
          netEntExtend.set("volumeLevel", 50);
        });
      });
      setTimeout(() => {
        $("#gameIframeWrapper").addClass('iframe-loaded');
      }, 3000);
    };

    // Error handling here.
    let error = function (e) {
      console.log(e);
    };

    window["netent"].launch(config, success, error);
  }

  // Mobile Netent Game config
  loadMobileNetentGames(resp, launchType) {
    let config = {
      gameId: resp.gameId,
      staticServerURL: resp.staticServer,
      gameServerURL: resp.gameServer,
      sessionId: resp.sessionId,
      walletMode: resp.walletMode,
      lobbyURL: resp.lobbyURL,
      keepAliveURL: "",
      keepAliveInterval: 15,
      casinoBrand: resp.casinoBrand,
      launchType: launchType,
      applicationType: resp.applicationType,
      targetElement: "netentgame",
      iframeSandbox: "allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-top-navigation-by-user-activation allow-same-origin allow-forms allow-pointer-lock",
      allowHtmlEmbedFullScreen: true,
      width: "100%",
      height: "100%",
      enforceRatio: false,
      language: resp.language
    };

    let success = function (netEntExtend) {
      // gameReady Listener - callback is used for iFrame Touch games launch
      netEntExtend.addEventListener("gameReady", function () {
        // Game ready handler to setup Operator specific code
      });
    };

    // Error handling here.
    let error = function (e) {
      console.log(e);
    };

    window["netent"].launch(config, success, error);
  }

  set lobbyDetails(lobbyDetails){
    this._lobbyDetails = lobbyDetails;
  }

  get lobbyDetails(){
    return this._lobbyDetails;
  }

  set gamesGroupedByGameGroup(gamesGroupedByGameGroup){
    this._gamesGroupedByGameGroup = gamesGroupedByGameGroup;
  }

  get gamesGroupedByGameGroup(){
    return this._gamesGroupedByGameGroup;
  }

  getLobbies(isForce = false){
    if (this.lobbyDetails && !isForce) {
      return of(this.lobbyDetails);
    } else{
      let localLobbyObservable: Observable<any>;
      if (this.lobbyObservable) {
        localLobbyObservable = this.lobbyObservable;
      } else {
        this.lobbyObservable = this.ajaxService.getLobbies().pipe(tap(lobbyDetails=>{
          this.lobbyDetails = _.sortBy(lobbyDetails, (lobby) => {
              return lobby.lobby_order * -1;
          });
          _.each(this.lobbyDetails,(lobby,index) => {
            this.lobbyDetails[index].gameGroupList = _.sortBy(lobby.gameGroupList, (gameGroup) => {
              return gameGroup.game_group_order * -1;
            })
          })
        }), share(), finalize(() =>
          this.lobbyObservable = null
        ));
        localLobbyObservable = this.lobbyObservable;
      }
      return localLobbyObservable; 
    }
  }

  groupGamesByGameGroups(){
    let gamesGroupedByGameGroup = {}
    _.each(this.allSlotsData, (game) => {
      if(game.gameGroupList){
        _.each(game.gameGroupList, (gameGroup) =>{
          let expandedGame = {...game};
          expandedGame['game_order_from_game_group'] = gameGroup.gameOrder;
          if(gamesGroupedByGameGroup[gameGroup.id]){
            gamesGroupedByGameGroup[gameGroup.id].push(expandedGame)
          } else{
            gamesGroupedByGameGroup[gameGroup.id]= [expandedGame]
          }
        })
      }
    })

    _.each(gamesGroupedByGameGroup,(gameGroupGames,key) => {
      this._gamesGroupedByGameGroup[key] = _.sortBy(gameGroupGames, (games) => {
        return games.game_order_from_game_group * -1;
      })
    })
  }

  
  setFavouriteGames(data) {
    this.favouriteGamesObj = data;
  }

  getFavouriteGames(isForce?) {
    if (this.isFavoriteGamesAvailable && !isForce && !_.isEmpty(this.favouriteGamesObj)){
      this.setFavouriteGames(this.favouriteGamesObj);
      return this.favouriteGamesObj;
    } else {
      return new Promise((resolve,reject)=>{
        if(this.favGamesDataCallStack.length > 0){
          this.favGamesDataCallStack.push(resolve);
        } else {
          this.favGamesDataCallStack.push(resolve);
          Promise.resolve(this.ajaxService.getFavouriteGames()).then(games => {
            let favGamesList = games['favorite'] && games['favorite']['favoriteGamesList'] ? games['favorite']['favoriteGamesList'] : null;
            this.favouriteGamesObj = {};
            if(games && games['favorite'] && favGamesList && favGamesList.length > 0) {
              favGamesList.forEach(favItem => {
                this.favouriteGamesObj[favItem.gameCode] = true;
              });
            }
            this.isFavoriteGamesAvailable = true;
            this.setFavouriteGames(this.favouriteGamesObj);
            for(let call in this.favGamesDataCallStack){
              this.favGamesDataCallStack[call](this.favouriteGamesObj);
            }
            this.favGamesDataCallStack=[];
          });
        }
      });
    }
  }

  setLatestPlayedGames(data) {
    this.latestPlayedGamesObject = data;
  }
 async getRecentlyPlayedGamesList(){
  let lastPlayedGames = await this.getLatestPlayedGames(true);
  let gameGroupDetails = this.getAllSlotData();
  let lastPlayedGamesResults = [];
  if(lastPlayedGames && gameGroupDetails) {
      lastPlayedGames.forEach(latestgamespsGameTypeId => {
        let games = gameGroupDetails.filter(({ psGameTypeId })=> psGameTypeId===latestgamespsGameTypeId);
        if(games && games.length !== 0 ) lastPlayedGamesResults.push(games[0]);
      }); 
  }
  return lastPlayedGamesResults;
}
  
  getLatestPlayedGames(isForce=false) {
    if (this.latestPlayedGamesObject && !this.forceLatestPlayedGames && isForce){
      this.setLatestPlayedGames(this.latestPlayedGamesObject);
      return this.latestPlayedGamesObject;
    }else{
      return new Promise((resolve,reject)=>{
        if(this.lastPlayedGamesDataCallStack.length > 0){
          this.lastPlayedGamesDataCallStack.push(resolve);
        }
        else{
          this.lastPlayedGamesDataCallStack.push(resolve);
          Promise.resolve(this.ajaxService.getLatestPlayedGames()).then(games => {
            if(games && games['gameDetails']){
              this.forceLatestPlayedGames = false;
              this.latestPlayedGamesObject = games['gameDetails'];
              this.setLatestPlayedGames(games['gameDetails']) 
            } 
            for(let call in this.lastPlayedGamesDataCallStack){
              this.lastPlayedGamesDataCallStack[call](this.latestPlayedGamesObject);
            }
            this.lastPlayedGamesDataCallStack=[];
          });
        }
      });
    }

  }

  clearGamesAndLobbies(){
   this.lobbyDetails =null;
   this.allSlotsData =null;
   this.favouriteGamesObj = {};
   this.isFavoriteGamesAvailable = false;
   this.favGamesDataCallStack = [];
  }
  providerObject(filteredGroups, data) {
    return filteredGroups.map((group) => ({
      provider_order: group.provider_order,
      name: group.name,
      vendorId: data.vendorId,
      vendorDisplayName: data.vendorDisplayName,
      id: group.id
    }));
  }

filterProviderList(allGames) {
  let modifiedArray = [];
  
  allGames?.forEach((data) => {
    const filteredGroups = data?.gameGroupList?.filter((group) =>
      group.game_asset_style === "quicklink" &&
      group.group_type === "manual" &&
      group.group_sub_type === "provider"
    );

    if (filteredGroups?.length > 0) {
      modifiedArray.push(...this.providerObject(filteredGroups, data)); 
    }
  });

  return modifiedArray;
}

uniqueProviderList(allGames){
  let allProviderList = this.filterProviderList(allGames);

  const uniqueArray = allProviderList.filter((value, index, self) => 
    index === self.findIndex((t) => (
      JSON.stringify(t) === JSON.stringify(value)
    ))
  ).sort((a, b) => b.provider_order - a.provider_order);

  return uniqueArray;
}

groupProvidersByNames(allGames){
  let uniqueProviderList = this.uniqueProviderList(allGames);
  let providerByGroup = _.groupBy(uniqueProviderList, 'id');
  return providerByGroup;
}

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}